import { render, staticRenderFns } from "./HotDeal.vue?vue&type=template&id=3d888c38&"
import script from "./HotDeal.vue?vue&type=script&lang=js&"
export * from "./HotDeal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports